import { observable, runInAction } from 'mobx';
import API from '../util/ApiUtil';
import ErrorUtil from '../util/ErrorUtil';

class ContactInfoStore {
  @observable accessor phone: string = null;
  @observable accessor email: string = null;
  @observable accessor customerId: number = null;

  public async fetchContactInfo(customerId: number) {
    if (this.customerId === customerId) {
      return Promise.resolve();
    }

    runInAction(() => (this.customerId = customerId));

    if (!customerId) {
      this.resetValues();
      return Promise.resolve();
    }

    try {
      const { data } = await API.get('/contact-info');
      runInAction(() => {
        this.email = data.email;
        this.phone = data.phone;
      });
    } catch (e) {
      ErrorUtil.pushErrorToTeliaRumAndLog(e);
      this.resetValues();
    }
  }

  private resetValues() {
    runInAction(() => {
      this.customerId = null;
      this.phone = null;
      this.email = null;
    });
  }
}

export default ContactInfoStore;
